var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playlists"},[_c('h1',{staticClass:"page-title"},[_vm._v("Playlists")]),_c('v-divider',{staticClass:"divider"}),_c('div',{staticClass:"playlist-grid"},_vm._l((_vm.$store.state.library.playlists),function(playlist){return _c('item-square',{key:playlist.id,attrs:{"item":playlist}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }